import { createStyles, InputStylesNames } from '@mantine/core';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';

export const useSearchFigmaStyles = createStyles<InputStylesNames>(() => {
  return {
    icon: {
      '.mantine-SearchInput-root[data-disabled="true"] & *': {
        color: COLORS_FLAT.n500,
      },
    },
    wrapper: {},
    withIcon: {},
    invalid: {},
    rightSection: {},
    root: {},
    input: {},
    disabled: {},
  };
});
export const searchFigmaStyleDefaults = {
  iconWidth: 33,
  rightSectionWidth: 38,
};
